import React, { useState } from 'react';
import styled from 'styled-components';
import { styled as MuiStyled } from '@mui/styles';
import { lighten } from '@mui/material/styles';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton as MuiIconButton } from '@mui/material';

import AllFileTypePreview from 'components/AllFileTypePreview';

const SColorButton = MuiStyled(MuiIconButton)(({ theme }) => ({
  backgroundColor: lighten(theme.palette.colors.red100, 0.8),
  transition: 'all .3s',
  '&:hover': {
    backgroundColor: theme.palette.colors.red200,
  },
  '&:active': {
    backgroundColor: lighten(theme.palette.colors.red100, 0.7),
  },
}));

const PreviewFilesList = ({ files, onDelete, isCanDelete = true }) => {
  const [deleted, setDeleted] = useState(null);
  const { t } = useTranslation();

  const embedPreviewConf = {
    height: '100%',
    maxHeight: '60px',
  };
  const imgPreviewConf = {
    height: '100%',
    maxHeight: '60px',
    maxWidth:'50%',
    minWidth:'50px'
  };

  const onRemoveItem = (fileId) => {
    setDeleted(fileId);
    setTimeout(() => {
      onDelete(fileId);
    }, 300);
  };

  return (
    <SFilePreviewList>
      {files?.map((file, idx) => (
        <SFilePreviewItem
          key={idx}
          className={deleted === file.id ? 'deleted' : ''}
        >
          <AllFileTypePreview
            file={file}
            embedWidth={'80'}
            embedPreviewConf={embedPreviewConf}
            imgPreviewConf={imgPreviewConf}
          />
          <SInfoWrapper>
            <SFileName>{file.name || file.title}</SFileName>
            {/* <SFlexWrapper>
              {file.lastModified && (
                <SFileDate>
                  {moment(file.lastModified).format('MMMM Do,YYYY')}
                </SFileDate>
              )}
              {file.size && (
                <SFileWeight>
                  {(file.size / (1024 * 1024)).toFixed(2)}
                  {t('Mb')}
                </SFileWeight>
              )}
            </SFlexWrapper> */}
          </SInfoWrapper>
          {isCanDelete ? (
            <SAction>
              <SColorButton
                size="small"
                color="error"
                aria-label="close"
                onClick={() => onRemoveItem(file)}
              >
                <CloseIcon classes={{ root: 'icon' }} color="error" />
              </SColorButton>
            </SAction>
          ) : (
            ''
          )}
        </SFilePreviewItem>
      ))}
    </SFilePreviewList>
  );
};

const SFilePreviewList = styled.div`
  margin: 5px 0;
  overflow: auto;
  max-height: 300px;
  width: 100%;
`;
const SFilePreviewItem = styled.div`
  border: 1px solid ${({theme}) => theme.palette.colors.gray200};
  box-sizing: border-box;
  border-radius: 5px;
  margin: 10px 0;
  padding: 7px 11px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 0.3s;
  &:not(:last-child) {
    margin: 10px 0 20px;
    &:after {
      position: absolute;
      bottom: -12px;
      left: 0;
      right: 0;
      display: block;
      content: '';
      width: 100%;
      height: 1px;
      border-bottom: 1px solid ${({theme}) => theme.palette.colors.gray200};
    }
  }
  &.deleted {
    opacity: 0.1;
  }
`;

const SInfoWrapper = styled.div`
  height: 100%;
  margin-left: 15px;
  min-width: 50%;
  max-width: calc(100% - 40px);
`;
const SFileName = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: ${({theme}) => theme.palette.colors.black100};
  max-width: 170px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const SFlexWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;
const SFileDate = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: ${({theme}) => theme.palette.colors.gray400};
`;
const SFileWeight = styled(SFileDate)`
  margin-left: 15px;
`;
const SAction = styled.div`
  margin-left: auto;
  align-self: center;
`;

export default PreviewFilesList;
